
export const company = {
  name: "", 
  role: "Data Fiduciary",
  userEmail: "", 
  userEmails: [], 
};

export function setCompanyFromTenant(tenant) {
  if (!tenant) return;
  company.name = tenant.name || tenant.organization_name || company.name;
}

export function setUserEmail(email) {
  if (!email) return;
  company.userEmail = email;
 
  if (!company.userEmails.includes(email)) {
    company.userEmails.push(email);
  }
}

export function addBulkUserEmails(emails) {
  const list = Array.isArray(emails)
    ? emails
    : String(emails || "")
        .split(",")
        .map((e) => e.trim())
        .filter(Boolean);

  list.forEach((email) => {
    if (email && !company.userEmails.includes(email)) {
      company.userEmails.push(email);
    }
  });

  
  if (!company.userEmail && company.userEmails.length > 0) {
    company.userEmail = company.userEmails[0];
  }
}


export function removeUserEmail(email) {
  company.userEmails = company.userEmails.filter((e) => e !== email);
  if (company.userEmail === email) {
    company.userEmail = company.userEmails[0] || "";
  }
}

export const privacyNotice = {
  version: "1.0.0",
  sections: [
    { id: "overview", label: "Overview", icon: "Info" },
    { id: "data-we-collect", label: "Data We Collect", icon: "Database" },
    { id: "why-we-collect", label: "Why We Collect", icon: "Users" },
    { id: "data-sharing", label: "Data Sharing", icon: "Share2" },
    { id: "your-rights", label: "Your Rights", icon: "ShieldCheck" },
    { id: "contact-us", label: "Contact Us", icon: "HelpCircle" },
  ],
  overview: {
    intro:
      "Whitehats Technologies acts as a Data Fiduciary and is committed to protecting your personal data.",
    cards: [
      {
        id: "who-we-are",
        title: "Who We Are",
        icon: "User",
        body: "Whitehats Technologies Pvt. Ltd. We are the Data Fiduciary responsible for your personal data.",
      },
      {
        id: "data-we-collect",
        title: "Data We Collect",
        icon: "Database",
        body: "We collect personal, financial, identity, usage, and other data that you provide to us.",
      },
      {
        id: "why-we-collect",
        title: "Why We Collect",
        icon: "Target",
        body: "We collect your data for specific purposes such as service delivery, compliance, security, and improvement.",
      },
      {
        id: "data-sharing",
        title: "Data Sharing",
        icon: "Share2",
        body: "We may share your data with authorized partners, service providers, and regulatory authorities as required.",
      },
    ],
    rights: {
      title: "Your Rights",
      items: [
        "Access your data",
        "Correct inaccurate data",
        "Request deletion",
        "Withdraw consent",
        "File a grievance",
        "Submit DSAR",
      ],
    },
  },
};

// Purpose selection config — unchanged
export const purposeGroups = {
  mandatory: {
    title: "Mandatory Purposes",
    icon: "Lock",
    accent: "red",
    locked: true,
    items: [
      {
        id: "identity-verification",
        label: "Identity Verification",
        description: "Required for identity verification",
        checked: true,
      },
      {
        id: "account-administration",
        label: "Account Administration",
        description: "To manage your account",
        checked: true,
      },
      {
        id: "security-monitoring",
        label: "Security Monitoring",
        description: "To ensure security and prevent fraud",
        checked: true,
      },
      {
        id: "regulatory-compliance",
        label: "Regulatory Compliance",
        description: "To comply with legal obligations",
        checked: true,
      },
    ],
  },
  optional: {
    title: "Optional Purposes",
    icon: "Sparkles",
    accent: "green",
    locked: false,
    items: [
      {
        id: "marketing-communications",
        label: "Marketing Communications",
        description: "To send you marketing materials",
        checked: false,
      },
      {
        id: "product-updates",
        label: "Product Updates",
        description: "To inform you about new products",
        checked: true,
      },
      {
        id: "research-analytics",
        label: "Research and Analytics",
        description: "To improve our services",
        checked: false,
      },
      {
        id: "customer-satisfaction-surveys",
        label: "Customer Satisfaction Surveys",
        description: "To understand your feedback",
        checked: false,
      },
    ],
  },
  thirdParty: {
    title: "Third-Party Sharing",
    icon: "Share2",
    accent: "purple",
    locked: false,
    items: [
      {
        id: "authorized-service-providers",
        label: "Authorized Service Providers",
        description: "Share with service providers",
        checked: true,
      },
      {
        id: "business-partners",
        label: "Business Partners",
        description: "Share with business partners",
        checked: false,
      },
      {
        id: "regulatory-authorities",
        label: "Regulatory Authorities",
        description: "Share with regulatory bodies",
        checked: true,
      },
    ],
  },
};

export const retentionPolicy = {
  title: "Retention & Control",
  periodLabel: "Data Retention Period",
  periodValue: "72 days",
  note: "You can withdraw your consent for optional purposes at any time from your dashboard.",
  policyUrl: "#",
};

// ---------------------------------------------------------------------------
// consentVersion: ab fixed "1.0.0" nahi — har consent bill/record ke hisaab
// se dynamic ho gaya hai. Default "1.0.0" fallback ke liye rakha hai.
// ---------------------------------------------------------------------------
export let consentVersion = "1.0.0";


export function setConsentVersion(version) {
  if (!version) return;
  consentVersion = version;
  privacyNotice.version = version;
}

// Generates a mock consent ID the way a backend sequence/uuid would.
export function generateConsentId() {
  const year = new Date().getFullYear();
  const random = Math.floor(100000 + Math.random() * 899999);
  return `CONS-${year}-${random}`;
}

export function formatTimestamp(date) {
  const d = date instanceof Date ? date : new Date(date);
  const datePart = d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  const timePart = d
    .toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .toUpperCase();
  return `${datePart}, ${timePart}`;
}